import { cn } from '@/utils/styles';
import { Info } from 'lucide-react';

import React from 'react';

import { Checkbox } from '@/components/ui/checkbox';

import { Tooltip } from './tooltip';

interface Props {
	id: string;
	title: string;
	description?: string;
	checkboxProps?: React.ComponentProps<typeof Checkbox>;
	checked?: boolean;
	disabled?: boolean;
	onCheckedChange?: (checked: boolean) => void;
	className?: string;
	tooltip?: string;
}

function CheckboxWithDetails({
	id,
	title,
	description,
	disabled,
	checked,
	checkboxProps = {},
	onCheckedChange,
	className,
	tooltip,
}: Props) {
	return (
		<div className={cn('flex items-start gap-2', className)}>
			<Checkbox
				id={id}
				checked={checked}
				onCheckedChange={onCheckedChange}
				className="mt-1 h-4 w-4 border-secondary data-[state=checked]:border-primary-blue data-[state=checked]:bg-primary-blue"
				disabled={disabled}
				{...checkboxProps}
			/>
			<div className="flex min-w-0 flex-col">
				{/* Outside the label so a wrapping title cannot orphan the icon, and clicking it does not toggle. */}
				<div className="flex items-start gap-1.5">
					<label
						htmlFor={id}
						className={cn('text-[15px] font-medium leading-6 text-primary hover:cursor-pointer')}
					>
						{title}
					</label>

					{tooltip && (
						<Tooltip text={tooltip}>
							<Info className="mt-1 size-4 shrink-0 text-secondary" />
						</Tooltip>
					)}
				</div>

				{description && <span className="block text-[13px] text-secondary">{description}</span>}
			</div>
		</div>
	);
}

export default CheckboxWithDetails;
